import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Phase I (I-A): public sign-up (outside the app shell, mounted in app/router.tsx) and the
// onboarding wizard (inside it).
const signup = () => import('./signup-pages');

export const publicRoutes: RouteObject[] = [
  { path: '/signup', lazy: page(signup, (m) => m.SignupPage) },
  { path: '/signup/verify', lazy: page(signup, (m) => m.SignupVerifyPage) },
];

export const routes: RouteObject[] = [{ path: 'onboarding', lazy: page(() => import('./onboarding-page'), (m) => m.OnboardingPage) }];
export const orgRoutes: RouteObject[] = [];
